import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendCustomFormat, BackendMutationUpdateCustomFormatArgs } from 'src/types/backend';

import { FRAGMENT_CUSTOM_FORMAT } from './schema';

const MUTATION = gql`
  mutation UpdateCustomFormat(
    $id: ID!
    $name: String!
    $instructions: String!
    $defaultForGenerationTools: [GenerationToolEnum!]
  ) {
    updateCustomFormat(
      id: $id
      name: $name
      instructions: $instructions
      defaultForGenerationTools: $defaultForGenerationTools
    ) {
      ...CustomFormat
    }
  }
  ${FRAGMENT_CUSTOM_FORMAT}
`;

type Variables = BackendMutationUpdateCustomFormatArgs;
type Result = BackendCustomFormat;

export const updateCustomFormat = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
